import { useState, MouseEvent } from "react";
import adminClasses from "../../../landing-pages/admin/admin.module.css";
import CompanyProfilesDashboardModel from "../../../../models/admin/company/response/CompanyProfilesDashboardModel";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import TableContainer from "@mui/material/TableContainer";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableHead from "@mui/material/TableHead";

interface CompanyProfilesDashboardGridProps {
    companyList: CompanyProfilesDashboardModel[];
    totalSize: number;
    currentPage: number;
    pagesize: number;
    sortColumn: string;
    sortDirection: "asc" | "desc";
    pageSizesList: number[];
    onPageChangeAction: (newPage: number) => void;
    onPageSizeChangeAction: (newPageSize: number) => void;
    onSortAction: (newSortColumn: string, sortDir: string) => void;
};

const CompanyProfilesDashboardGridComponent = (props: CompanyProfilesDashboardGridProps) => {
    const columnsCompany = [
        { key: "CompanyName", text: "Company Name", sort: true, searchable: false },
        { key: "NoOfProfilesReceived", text: "No Of Profiles Received", sort: false, searchable: false },
        { key: "NoOfProfilesScheduled", text: "No of Profiles Scheduled", sort: false, searchable: false },
        { key: "NoOfProfilesRated", text: "No of Profiles Rated", sort: false, searchable: false }
    ];

    const createSortHandler = (property: string) => (event: React.MouseEvent) => {
        props.onSortAction(property, props.sortDirection === "asc" ? "desc" : "asc")
    };

    const handleChangePage = (event: any, newPage: number) => {
        props.onPageChangeAction(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        props.onPageSizeChangeAction(parseInt(event.target.value, 10));
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {columnsCompany.map((column: any) => (
                                    <TableCell key={column.key} className="table-header-cell">
                                        {column.sort &&
                                            <TableSortLabel
                                                active={props.sortColumn === column.key}
                                                direction={props.sortColumn === column.key ? props.sortDirection : "asc"}
                                                onClick={createSortHandler(column.key)}>
                                                {column.text}
                                            </TableSortLabel>
                                        }
                                        {!column.sort &&
                                            <span>{column.text}</span>
                                        }
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.companyList.map((company: CompanyProfilesDashboardModel, index) => (
                                <TableRow>
                                    <TableCell>{company.companyName}</TableCell>
                                    <TableCell>{company.noOfProfilesReceived}</TableCell>                                  
                                    <TableCell>{company.noOfProfilesScheduled}</TableCell>
                                    <TableCell>{company.noOfProfilesRated}</TableCell>                                 
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table> 
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={props.pageSizesList}
                    component="div"
                    count={props.totalSize}
                    rowsPerPage={props.pagesize}
                    page={props.currentPage - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </div> 
    );
};
export default CompanyProfilesDashboardGridComponent;